import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignupTrialComponent } from '@app/modules/user/signup/signup-trial/signup-trial.component';
import { SignupValidatePhoneComponent } from '@app/modules/user/signup/signup-validate-phone/signup-validate-phone.component';
import { RedirectIfLoggedInGuard } from '@app/shared/guards/redirect-if-logged-in.guard';
import { SignupFlowGuard } from '@app/shared/guards/signup-flow.guard';
import { SignupChannelsComponent } from './signup-channels/signup-channels.component';
import { SignupContinueComponent } from './signup-continue/signup-continue.component';
import { SignupDoneComponent } from './signup-done/signup-done.component';
import { SignupMenuComponent } from './signup-menu/signup-menu.component';
import { SignupMessagingRulesComponent } from './signup-messaging-rules/signup-messaging-rules.component';
import { SignupPasswordComponent } from './signup-password/signup-password.component';
import { SignupPropertiesComponent } from './signup-properties/signup-properties.component';
import { SignupReviewListingsComponent } from './signup-review-listings/signup-review-listings.component';
import { SignupStartComponent } from './signup-start/signup-start.component';
import { SignupStatusComponent } from './signup-status/signup-status.component';
import { SignupWelcomeComponent } from './signup-welcome/signup-welcome.component';
import { SignupWithAirbnbComponent } from './signup-with-airbnb/signup-with-airbnb.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'welcome',
    pathMatch: 'full',
  },
  {
    path: 'about',
    redirectTo: 'welcome',
    pathMatch: 'full',
  },
  {
    path: 'airbnb',
    component: SignupWithAirbnbComponent,
    canActivate: [],
    data: {
      title: 'Signup - Airbnb',
    },
  },
  {
    path: 'status',
    component: SignupStatusComponent,
    canActivate: [],
    data: {
      title: 'Signup - Status',
    },
  },

  {
    path: 'continue/:token',
    component: SignupContinueComponent,
    data: {
      title: 'Signup - Continue',
    },
  },
  {
    path: 'welcome',
    component: SignupWelcomeComponent,
    canActivate: [RedirectIfLoggedInGuard, SignupFlowGuard],
    data: {
      title: 'Signup - Welcome',
    },
  },
  {
    path: 'validate-phone',
    component: SignupValidatePhoneComponent,
    data: {
      title: 'Signup',
    },
  },
  {
    path: 'start',
    component: SignupStartComponent,
    data: {
      title: 'Signup',
    },
  },
  {
    path: 'properties',
    component: SignupPropertiesComponent,
    data: {
      title: 'Signup - Properties',
    },
  },
  {
    path: 'channels',
    component: SignupChannelsComponent,
    data: {
      title: 'Signup - Channels',
    },
  },
  {
    path: 'messaging-rules',
    component: SignupMessagingRulesComponent,
    data: {
      title: 'Signup - Messaging Rules',
    },
  },
  {
    path: 'password',
    component: SignupPasswordComponent,
    data: {
      title: 'Signup - Set your password',
    },
  },
  {
    path: 'trial',
    component: SignupTrialComponent,
    data: {
      title: 'Signup - Trial',
    },
  },
  {
    path: 'menu',
    component: SignupMenuComponent,
    data: {
      title: 'Signup - Onboarding',
    },
  },

  {
    path: 'review-listings',
    component: SignupReviewListingsComponent,
    data: {
      title: 'Signup - Review Listings',
    },
  },
  {
    path: 'done',
    component: SignupDoneComponent,
    data: {
      title: 'Signup - Complete!',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SignupRoutingModule {}
